






// // ElementDetailOfACard.jsx
// import React, { useState } from "react";
// import ReactImageMagnify from "@blacklab/react-image-magnify";
// import "./style.scss";
// import CarouselCardsSubsection from "../iconosv0/src/screens/ElementHomePage/sections/CarouselCardsSubsection/CarouselCardsSubsection";

// /* images */
// import image1 from "./static/img/image-1-1.png";
// import image2 from "./static/img/image-2.png";
// import thumb2 from "./static/img/image-2-1.png";
// import avatar from "./static/img/avatar.png";
// import line14 from "./static/img/line-14.svg";
// import iconVector from "./static/img/vector.svg";    // share
// import iconVector1 from "./static/img/vector-1.svg"; // like
// import iconVector2 from "./static/img/vector-2.svg"; // views

// /* i18n — same pattern as CreateCardForm */
// import translations from "../utils/language/translations.json";
// import { useTranslation } from "react-i18next";

// const ElementDetailOfACard = () => {
//   const { i18n } = useTranslation();
//   const currentLang = i18n.language;
//   const t = (key) => translations.CreateCardForm?.[key]?.[currentLang] ?? key;

//   // mock data for now
//   const title = "Connor McDavid #456";
//   const seller = { name: "Barry Becker", avatar };
//   const description =
//     "Lorem ipsum dolor sit amet consectetur. Dignissim dictumst odio bibendum risus ullamcorper in. Cras semper morbi et tincidunt nulla a. Faucibus erat ornare sagittis vitae vitae mauris massa fringilla. Non vitae scelerisque tortor.";
//   const badges = ["Rookie (RC)", "/25"];
//   const views = 7;

//   const thumbs = [
//     { small: image1, large: image1, alt: t("Front") },
//     { small: image2, large: image2, alt: t("Back") },
//   ];
//   const [selectedImg, setSelectedImg] = useState(thumbs[0]);
//   const [zooming, setZooming] = useState(false);

//   return (
//     <main className="card-page">
//       <section className="container card-detail">
//         <span aria-hidden className="page-glow page-glow--left" />
//         <span aria-hidden className="page-glow page-glow--bottom" />
//         <span aria-hidden className="page-grain" />
//         <span aria-hidden className="page-arc" />

//         {/* Top bar */}
//         <div className="card-detail__topbar">
//           <button
//             type="button"
//             className="btn-text back"
//             onClick={() => window.history.back()}
//           >
//             {t("Go Back")}
//           </button>
//         </div>

//         <div className="card-detail__grid">
//           {/* LEFT: media */}
//           <aside className="card-media">
//             <div
//               className={`card-media__stage stage--framed ${zooming ? "is-zooming" : ""}`}
//               onMouseEnter={() => setZooming(true)}
//               onMouseLeave={() => setZooming(false)}
//             >
//               <ReactImageMagnify
//                 imageProps={{
//                   alt: title,
//                   src: selectedImg.small,
//                   width: "100%",
//                   height: "100%",
//                   style: { objectFit: "cover", borderRadius: 14 },
//                 }}
//                 magnifiedImageProps={{
//                   src: selectedImg.large,
//                   width: 1200,
//                   height: 1600,
//                 }}
//                 magnifyContainerProps={{
//                   width: 280,
//                   height: 360,
//                   style: { borderRadius: 12, boxShadow: "0 10px 30px rgba(0,0,0,.4)" },
//                 }}
//               />
//             </div>

//             {/* thumbs */}
//             <div className="card-media__thumbs" role="tablist" aria-label={t("Thumbnails")}>
//               {thumbs.map((tmb, i) => {
//                 const active = selectedImg.small === tmb.small;
//                 return (
//                   <button
//                     key={tmb.alt + i}
//                     type="button"
//                     role="tab"
//                     aria-selected={active}
//                     className={`thumb ${active ? "is-active" : ""}`}
//                     onClick={() => setSelectedImg(tmb)}
//                     title={tmb.alt}
//                   >
//                     <img src={tmb.small} alt="" />
//                   </button>
//                 );
//               })}
//             </div>
//           </aside>

//           {/* RIGHT: info */}
//           <section className="card-info">
//             <header className="card-info__header">
//               <div className="actions__icons">
//                 <button className="icon-btn" type="button" aria-label={t("Share")}>
//                   <img src={iconVector} alt="" aria-hidden="true" />
//                 </button>
//                 <button className="icon-btn" type="button" aria-label={t("Like")}>
//                   <img src={iconVector1} alt="" aria-hidden="true" />
//                 </button>
//               </div>

//               <div className="title-row">
//                 <h1 className="card-title">{title}</h1>
//                 <div className="title-row__meta">
//                   <span className="status-pill">{t("For Sale")}</span>
//                   <div className="views" aria-label={`${views} ${t("Views")}`}>
//                     <img src={"asd/asd"} alt="" aria-hidden="true" />
//                     <span>{views} {t("Views")}</span>
//                     <img src={iconVector2} alt="" aria-hidden="true" />
//                   </div>
//                 </div>
//               </div>

//               <div className="pills" role="list">
//                 {badges.map((b) => (
//                   <span key={b} className="pill" role="listitem">
//                     {b}
//                   </span>
//                 ))}
//               </div>
//             </header>

//             {/* price row */}
//             <div className="price-grid price-grid--dividers" aria-label={t("Price summary")}>
//               <div className="price-item">
//                 <div className="label">{t("Price")}</div>
//                 <div className="value2 pricing">$150.00</div>
//               </div>
//               <div className="price-item">
//                 <div className="label">{t("Paid Price")}</div>
//                 <div className="value2">$105.00</div>
//               </div>
//               <div className="price-item">
//                 <div className="label">{t("Estimate Value")}</div>
//                 <div className="value2">$150</div>
//               </div>
//             </div>

//             {/* details */}
//             <div className="details-grid">
//               <div className="kv"><div className="k">{t("Set")}</div><div className="v">2018–19 Upper Deck</div></div>
//               <div className="kv"><div className="k">{t("Variation")}</div><div className="v">Young Guns – Base</div></div>
//               <div className="kv"><div className="k">{t("Sports")}</div><div className="v">Hockey</div></div>
//               <div className="kv"><div className="k">{t("Condition (Raw)")}</div><div className="v">NM</div></div>
//               <div className="kv"><div className="k">{t("Uniform")}</div><div className="v">{t("N/A")}</div></div>
//               <div className="kv"><div className="k">{t("Location")}</div><div className="v">{t("N/A")}</div></div>
//               <div className="kv"><div className="k">{t("Added On")}</div><div className="v">2025-03-27</div></div>
//               <div className="kv"><div className="k">{t("For Sale")}</div><div className="v">{t("Yes")}</div></div>
//             </div>

//             {/* actions */}
//             <div className="actions" aria-label={t("Actions")}>
//               <button className="btn-primary" type="button">
//                 <span className="btn-ico" aria-hidden>👜</span>
//                 <span>{t("Add/ Sell yours")}</span>
//               </button>
//             </div>

//             <div className="seller">
//               <img className="seller__avatar" src={seller.avatar} alt="" />
//               <span className="seller__name">{seller.name}</span>
//               <a className="seller__score" href="#ratings">100% (34)</a>
//             </div>

//             <p className="card-desc">{description}</p>

//             <p className="issue">
//               <span>{t("Something wrong?")}</span> <a href="/support">{t("Let us know.")}</a>
//             </p>
//           </section>
//         </div>

//         <img src={line14} style={{ width: "100%", marginTop: "10px" }} alt="" />
//       </section>

//       {/* related */}
//       <div className="hero__carousel">
//         <CarouselCardsSubsection title={t("Discover More Cards")} t={t} />
//       </div>
//     </main>
//   );
// };

// export default ElementDetailOfACard;






































import React, { useContext, useEffect, useMemo, useRef, useState,useCallback,useLayoutEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import ReactImageMagnify from "@blacklab/react-image-magnify";
import axios from "axios";
import "./style.scss";

import { useSport } from "../utils/SportsProvider";
// Reuse your proven building blocks from the old page
import SaleModals from "../components/GridViewSellTrade/SaleModals";

import ModalTradeOffer from "../components/GridViewSellTrade/ViewSaleTradeOffer/ModalTradeOffer";
import ReportFromFullPageListing from "../components/reportForm/ReportFromFullPageListing";
import FavoriteIcon from "../components/Favorite/FavoriteIcon";
import { useFavorites } from "../components/Favorite/FavoriteProvider";
import { AuthContext } from "../components/login/AuthContext";
import SeoHelmet from "../Seo/SeoHelmet";
import { hasConsent } from "../components/login/hasConsent";
import { getCountryCode } from "../components/UsefulComponent/CountryMapping";
import CarouselCardsSubsection from "../iconosv0/src/screens/ElementHomePage/sections/CarouselCardsSubsection/CarouselCardsSubsection";
import comingSoon from "../assets/istockphotoImageComingSoon.jpg";
// i18n
import translations from "../utils/language/translations.json";
import { useTranslation } from "react-i18next";

// assets you used in the new mock
import iconShare from "./static/img/vector.svg";
import iconLike from "./static/img/vector-1.svg";
import iconViews from "./static/img/vector-2.svg";
import dividerLine from "./static/img/line-14.svg";
import { FaShoppingBag } from "react-icons/fa";
import shoppingbag from "./static/img/shopping-bag.svg";
import ReturnColorsButton from "../components/MatchTaCarte/ReturnColorsButton";
import MatchMyCardButton from "../components/MatchTaCarte/MatchMyCardButton";


const ElementDetailOfACard = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.DetailedCardView?.[key]?.[currentLang]
    ?? translations.CreateCardForm?.[key]?.[currentLang]
    ?? translations.Login?.[key]?.[currentLang]
    ?? key;
 const { state } = useSport(); // state.sport is "Hockey" | "Pokemon"   state.sport!=='Pokemon'
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
 const [isSaleModalOpen,setIsSaleModalOpen] = useState(false)
  // auth + favorites (same as old)
  const { userId, liveCsrfToken } = useContext(AuthContext);
  const {
    favoriteCards,
    addFavoriteCard,
    removeFavoriteCard,
    setFavoriteCards,
  } = useFavorites();



  // state (same model as old)
  const [selectedCard, setSelectedCard] = useState(location.state?.card || null);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(!selectedCard);
  const [isTradeModalOpen, setIsTradeModalOpen] = useState(false);



const stageRef = useRef(null);
const [mounted, setMounted] = useState(false);
const [dims, setDims] = useState({ w: 0, h: 0 });

useEffect(() => setMounted(true), []);




  // media state for the new UI
  // Native share with clipboard + legacy fallback
const onShare = useCallback(async () => {
  try {
    const url = window.location.href; // canonical enough for now
    const title =
      `${selectedCard?.playerName || selectedCard?.Name || ""} ${selectedCard?.cardName || ""}`.trim() ||
      "CardsFolio";
    const text = t ? t("Check out this card on CardsFolio") : "Check out this card on CardsFolio";

    if (navigator.share) {
      await navigator.share({ title, text, url });
      return;
    }

    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(url);
      // Optional: toast.success(t?.("Link copied to clipboard") ?? "Link copied to clipboard");
      return;
    }

    // Legacy fallback (non-HTTPS / older browsers)
    const ta = document.createElement("textarea");
    ta.value = url;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
    // Optional: toast.success(t?.("Link copied to clipboard") ?? "Link copied to clipboard");
  } catch (err) {
    console.error("Share failed:", err);
    // Optional: toast.error(t?.("Could not share link") ?? "Could not share link");
  }
}, [t, selectedCard]);
  const [zooming, setZooming] = useState(false);




  // ---------- fetch card if needed (old behavior) ----------
  useEffect(() => {
    if (!selectedCard) {
      axios
        .get(`${process.env.REACT_APP_API_BASE}/getSingleUserCard/${id}`)
        .then((res) => {
          if (!res.data || res.data.length === 0) {
            setError("404: This listing is no longer available.");
          } else {
            setSelectedCard(res.data[0]);
          }
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error fetching card data:", err);
          setError("Something went wrong. Please try again.");
          setLoading(false);
        });
    }
  }, [id, selectedCard]);

  const isOwner    = parseInt(selectedCard?.UserId) === parseInt(userId);

  const isPokemon = selectedCard?.CatalogType === "Pokemon";
const isHockey = selectedCard?.CatalogType !== "Pokemon";
console.log('here it is selectedCard',selectedCard)
  // ---------- view count (from old page) ----------
  const getUserDeviceInfo = async () => {
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    try {
      const response = await fetch("https://ipapi.co/json/");
      const loc = await response.json();
      const userLocation = `${loc.city}, ${loc.country_name}`;
      return { userAgent, deviceType, userLocation };
    } catch {
      return { userAgent, deviceType, userLocation: "Unknown Location" };
    }
  };
  const cleanUpOldTimestamps = () => {
    const expiration = 24 * 60 * 60 * 1000;
    const now = Date.now();
    for (const key in sessionStorage) {
      if (key.startsWith("lastView_")) {
        const ts = parseInt(sessionStorage.getItem(key), 10);
        if (now - ts > expiration) sessionStorage.removeItem(key);
      }
    }
  };
  const handleAddViewCount = async (listingId, userCardId, uid) => {
    const key = `lastView_${listingId}`;
    const last = sessionStorage.getItem(key);
    const now = Date.now();
    const cooldown = 30 * 60 * 1000;
    cleanUpOldTimestamps();
    if (!last || now - last > cooldown) {
      const { userAgent, deviceType, userLocation } = await getUserDeviceInfo();
      axios
        .put(`${process.env.REACT_APP_API_BASE}/api/listing/incrementViewCount`, {
          listingId, userCardId, userId: uid || null, userLocation, deviceType, userAgent,
        })
        .then(() => sessionStorage.setItem(key, now.toString()))
        .catch((e) => console.error("Error incrementing view count:", e));
    }
  };
  useEffect(() => {
    if (selectedCard && parseInt(selectedCard.UserId) !== parseInt(userId)) {
      handleAddViewCount(selectedCard.ID, selectedCard.id, userId);
    }
  }, [selectedCard, userId]);

  // ---------- actions (old behavior) ----------
  const triggerLogin = () => {
    console.log("je test trigger")
    if (!userId) {
      // Save the intended path to local storage
      console.log("je test trigger123")
       if (hasConsent()) {
        console.log("je test trigger456")
      localStorage.setItem(
        "intendedPath",
        window.location.pathname + window.location.search
      );}
      console.log("je test trigger123123")
         navigate(i18n.language === 'fr' ? `/fr/login`:`/login`);
      return;
    }
  };
  const toggleFavorite = async (cardUserCardId, cardId) => {
    if (triggerLogin()) return;
    const existing = favoriteCards.find((c) => c.userCardId === cardUserCardId);
    const wasFav = Boolean(existing);
    let newWatchListId;
    try {
      if (wasFav) {
        await removeFavoriteCard(cardUserCardId);
        newWatchListId = null;
      } else {
        await addFavoriteCard(cardUserCardId, cardId);
        newWatchListId = existing?.WatchListId || null;
      }
      setFavoriteCards((prev) =>
        wasFav ? prev.filter((c) => c.userCardId !== cardUserCardId)
               : [...prev, { userCardId: cardUserCardId, WatchListId: newWatchListId }]
      );
    } catch (e) {
      console.error("Error toggling favorite:", e);
    }
  };
  const onAddSellYours = () => {
    if (triggerLogin()) return;
    const copy = { ...selectedCard };
    copy.Location = "";
    copy.PaidPrice = 0;
    copy.isPC = "NotisPC";
    copy.isOnEbay = "NotisOnEbay";
    copy.isForTrade = "NotisForTrade";
    copy.isForSale = "NotisForSale";
    copy.ImageFront = "";
    copy.ImageUserBack = "";
    navigate(i18n.language === "fr" ? "/fr/createCardForm" : "/createCardForm", {
      state: { card: copy, isAddingNewCard: true },
    });
  };
  const onEdit = () => {
    navigate(i18n.language === "fr" ? `/fr/EditCard/${selectedCard.id}` : `/EditCard/${selectedCard.id}`, {
      state: { card: selectedCard },
    });
  };

  const buildImages = (card) => {
 const front =
  card?.ImageFront ||
  card?.PokemonImageFront ||
  card?.Image ||
  comingSoon;
  const back =
    card?.ImageUserBack ||
    card?.ImageBack ||
    comingSoon;

  return [
    { small: front, large: front, alt: "Front" },
    { small: back,  large: back,  alt: "Back"  },
  ];
};
const images = useMemo(() => buildImages(selectedCard), [selectedCard]);

  const [selectedImg, setSelectedImg] = useState(() => buildImages(location.state?.card)[0]);

  useLayoutEffect(() => {
  if (!stageRef.current) return;
  const rect = stageRef.current.getBoundingClientRect();
  // fallback size if rect is 0 on first paint
  const w = Math.max( rect.width  || 480, 320);
  const h = Math.max( rect.height || 640, 420);
  setDims({ w: Math.round(w), h: Math.round(h) });
}, [selectedImg]); // recompute when image changes

const saleAvailable =
  selectedCard?.isForSale === "isForSale" &&
  !isOwner &&
  Number(selectedCard?.Price) >= 0;

const tradeAvailable =
  selectedCard?.isForTrade === "isForTrade" &&
  !isOwner &&
  Number(selectedCard?.EstimateValue) >= 0;

const formatCAD = (n) =>
  (Number(n) || 0).toLocaleString("fr-CA", { style: "currency", currency: "CAD" });

// Initialize with something non-null immediately (even on the very first render)


// When selectedCard changes (e.g., after fetch), update the selected image safely
useEffect(() => {
  const list = buildImages(selectedCard);
  setSelectedImg((prev) => {
    // keep the same side (front/back) if possible; otherwise default to list[0]
    if (!prev) return list[0];
    const isFront = prev.alt === "Front";
    return isFront ? list[0] : list[1];
  });
}, [selectedCard]);
// ---------- derived display data for your new UI ----------
  // const images = useMemo(() => {
  //   // Prefer user images; fallback to stock placeholders as in old page
  //   console.log('initlamenet',selectedCard?.ImageFront,selectedCard?.Image,'ok')
  //   const front =
  //     selectedCard?.ImageFront ||
  //     selectedCard?.Image ||
  //     require("../assets/istockphotoImageComingSoon.jpg");
  //   const back =
  //     selectedCard?.ImageUserBack ||
  //     selectedCard?.ImageBack ||
  //     require("../assets/istockphotoImageComingSoon.jpg");

  //   return [
  //     { small: front, large: front, alt: t("Front") },
  //     { small: back,  large: back,  alt: t("Back")  },
  //   ];
  // }, [selectedCard]);

useEffect(() => {
  if (!images?.length) return;

  if (!selectedImg) {
    setSelectedImg(images[0]);
    return;
  }

  const isFront = selectedImg.alt === t("Front");
  const next = isFront ? images[0] : images[1];

  // Only set if underlying src actually changed
  if (selectedImg.small !== next.small || selectedImg.large !== next.large || selectedImg.alt !== next.alt) {
    setSelectedImg(next);
  }
}, [images, t, selectedImg]);

  // badges row reused with your new “pill” design
  const badges = useMemo(() => {
  const list = [];

  if (isPokemon) {
    if (selectedCard?.Rarity) list.push(selectedCard.Rarity);
    if (selectedCard?.HoloOverride) list.push(selectedCard.HoloOverride);
    if (selectedCard?.Supertype) list.push(selectedCard.Supertype);
    return list;
  }

  if (selectedCard?.IsRookie === "Rookie(RC)") list.push(t("Rookie(RC)"));
  if (selectedCard?.IsPatch === "Patch") list.push(t("Patch"));
  if (selectedCard?.IsJersey === "Jersey") list.push(t("Jersey"));
  if (selectedCard?.IsAuto === "Auto") list.push(t("Auto"));
  if (selectedCard?.numbered > 0) list.push("/" + selectedCard.numbered);

  return list;
}, [selectedCard, currentLang, isPokemon]);

  const statusPills = useMemo(() => {
    const pills = [];
    if (selectedCard?.isForSale === "isForSale") pills.push(t("For Sale"));
    if (selectedCard?.isForTrade === "isForTrade") pills.push(t("For Trade"));
    if (selectedCard?.isOnEbay === "isOnEbay") pills.push(t("OnEbay"));
    if (selectedCard?.isPC === "isPC") pills.push(t("PC"));
    return pills;
  }, [selectedCard, currentLang]);

  const sellerInfo = useMemo(
    () => selectedCard && ({
      ShowName: selectedCard.ShowName,
      ProfilPicture: selectedCard.ProfilPicture,
      NumberOfTransactions: selectedCard.NumberOfTransactions,
      AverageX5: (selectedCard.AverageRating * 20).toFixed(1),
      City: selectedCard.City || "Unknown",
      Country: selectedCard.Country || "Unknown",
      CountryCode: getCountryCode(selectedCard.Country || "NA"),
    }),
    [selectedCard]
  );

 // replace your current priceGrid useMemo with this
const priceGrid = useMemo(() => {
  const isOwner    = parseInt(selectedCard?.UserId) === parseInt(userId);
  const isForTrade = selectedCard?.isForTrade === "isForTrade" || isOwner;
  
  const paid  = selectedCard?.PaidPrice;
  const price = selectedCard?.Price;
  const tv    = selectedCard?.EstimateValue;

  const items = [
    // Price (shown when provided)
    (price != null && price !== "") && {
      label: t("Price"),
      value: Number(price),
    },

    // Paid Price (owner only)
    (isOwner && paid != null && paid !== "") && {
      label: t("Paid Price"),
      value: Number(paid),
    },

    // Estimate Value / TV (only when For Trade)
    (isForTrade && tv != null && tv !== "") && {
      label: t("Estimate Value"),
      value: Number(tv),
    },
  ];

  // remove any falsey entries created by the conditions above
  return items.filter(Boolean);
}, [selectedCard, userId, currentLang]);



  // short intro blurb (fallback to nothing)
const intro = useMemo(() => {
  const txt = selectedCard?.OtherDetails || "";
  return txt.length > 220 ? txt.slice(0, 210) + "…" : txt;
}, [selectedCard, currentLang]);
  // views/watchlist from old model
  const views = selectedCard?.ViewCounts ?? 0;
  const watchlist = selectedCard?.WatchListCounts ?? 0;

  // loading/error
  if (loading) return <div style={{ padding: 24 }}>{t("Loading...")}</div>;
  if (error) {
    return (
      <section className="card-page">
        <div className="container" style={{ textAlign: "center", padding: 48 }}>
          <h2 style={{ padding: 24 }}>{error}</h2>
          <button
            className="btn-primary"
            onClick={() => navigate(i18n.language === "fr" ? "/fr/home" : "/home")}
          >
            {t("Go Home")}
          </button>
        </div>
      </section>
    );
  }

  const title = isPokemon
  ? `${selectedCard?.cardName || selectedCard?.Name || ""}${selectedCard?.NumberInSet ? ` #${selectedCard.NumberInSet}` : selectedCard?.NumberBehind ? ` #${selectedCard.NumberBehind}` : ""}`
  : `${selectedCard?.Name || ""} #${selectedCard?.NumberBehind || ""}`;

  const tradeButtonVisible = selectedCard?.isForTrade === "isForTrade";
  const buyButtonVisible = true;


const openSale = () => {
    setIsSaleModalOpen(true);
  };






  return (
    <main className="card-page">
      {/* SEO like old page */}
      {selectedCard && (
        <SeoHelmet
          type="listing"
          data={{ playerName: selectedCard?.playerName, cardName: selectedCard?.cardName, ImageFront: selectedCard?.ImageFront }}
        />
      )}

      <section className="container card-detail">
        <span aria-hidden className="page-glow page-glow--left" />
        <span aria-hidden className="page-glow page-glow--bottom" />
        <span aria-hidden className="page-grain" />
        <span aria-hidden className="page-arc" />

        {/* Top bar */}
    {/* Top bar */}
<div className="card-detail__topbar">
  <button
    type="button"
    className="btn btn--ghost btn--icon"
    title={t("Back")}
    aria-label={t("Back")}
    onClick={() => window.history.back()}
  >
    <span className="ico">←</span>
    <span className="btn__label">{t("Back")}</span>
  </button>

  <div className="topbar-actions">
    {parseInt(selectedCard.UserId) === parseInt(userId) && (
      <>
        <button
          type="button"
          className="btn btn--ghost"
          onClick={onEdit}
          title={t("Edit")}
          aria-label={t("Edit")}
        >
          ✎ <span className="btn__label">{t("Edit")}</span>
        </button>



        {/* <div className="menu">
          <button
            type="button"
            className="btn btn--ghost btn--icon"
            aria-haspopup="menu"
            aria-label={t("Open menu")}
            title={t("More")}
          >
            ⋮
          </button>
          <div className="menu__list" role="menu">
            <button role="menuitem" className="menu__item" onClick={onAddSellYours}>
              <img src={shoppingbag}/> {t("Add/Sell yours")}
            </button>
           
          </div>
        </div> */}
      </>
    ) }
  </div>
</div>


        <div className="card-detail__grid">
          {/* LEFT: media (your new framed stage + magnify) */}
          <aside className="card-media">
        <div
  ref={stageRef}
  className={`card-media__stage stage--framed ${zooming ? "is-zooming" : ""}`}
  // Optional: remove these 2 lines (see point 2)
  onMouseEnter={() => setZooming(true)}
  onMouseLeave={() => setZooming(false)}
>
  {mounted && selectedImg && dims.w > 0 && dims.h > 0 && (
    <ReactImageMagnify
      key={selectedImg.small}   // force clean remount on image swap
      imageProps={{
        alt: title,
        src: selectedImg.small,
        width: '100%',          // <<< numbers, not "100%"
        height: '100%',         // <<<
        style: { objectFit: "cover", borderRadius: 14 },
      }}
      magnifiedImageProps={{
        src: selectedImg.large,
        width: 1200,
        height: 1800,
      }}
      magnifyContainerProps={{
        width: 500,
        height: 700,
        style: { borderRadius: 12, boxShadow: "0 10px 30px rgba(0,0,0,.4)" },
      }}
    />
  )}
</div>


            {/* thumbs */}
            <div className="card-media__thumbs" role="tablist" aria-label={t("Thumbnails")}style={{marginLeft:'1rem'}}>
              {images.map((tmb, i) => {
                const active = selectedImg?.small === tmb.small;
                return (
                  <button
                    key={tmb.alt + i}
                    type="button"
                    role="tab"
                    aria-selected={active}
                    className={`thumb ${active ? "is-active" : ""}`}
                    onClick={() => setSelectedImg(tmb)}
                    title={tmb.alt}
                  >
                    <img src={tmb.small} alt="" />
                  </button>
                );
              })}
            </div>

            {/* report + add/sell yours (old actions, placed under images like your new mock) */}
         <div className="card-media__tools">

  <button
    className="btn-baseBlue"
    onClick={onAddSellYours}
    title={t("Add/Sell yours")}
    style={{display:'flex',alignItems:'center',gap:'8px',width:'100%',justifyContent:'center',padding:'16px'}}
  >
               <img src={shoppingbag} style={{height:'20px',width:'20px'}}/>{t("Add/Sell yours")}
  </button>
</div>


{/* <ReturnColorsButton imageUrl={selectedImg?.large} />
<MatchMyCardButton
  imageUrl={selectedImg?.large}
  cardId={selectedCard?.CardId}
  cardTitle={selectedCard?.variation}
  gradingCompany={selectedCard?.GradeCompany}
  language={i18n?.language === "fr" ? "fr" : "en"}
/> */}

          </aside>
          {/* RIGHT: info (your new layout, real data) */}
          <section className="card-info">
            <header className="card-info__header">
              <div className="actions__icons">
                {/* <button className="icon-btn" type="button" aria-label={t("Share")}>
                  <img src={iconShare} alt="" aria-hidden="true" />
                </button>
                <button className="icon-btn" type="button" aria-label={t("Like")}>
                <FavoriteIcon
          cardId={selectedCard.CardId}
          cardUserCardId={selectedCard.userCardId}
          isFavorite={favoriteCards.some((c) => c.userCardId === selectedCard.userCardId)}
          cardUserId={selectedCard.UserId}
          userId={userId}
          toggleFavorite={toggleFavorite}
          size={28}
        />
                </button> */}
                  <div className="views" aria-label={`${views} ${t("Views")}`}>
                    <img src={iconViews} alt="" aria-hidden="true" />
                    <span>
                      {views} {t("Views")} · {watchlist} {t("Watchlist")}
                    </span>
                  </div>
              </div>


              <div className="title-row">
                <h1 className="card-title">{title}</h1>
               
              </div>

              {badges?.length ? (
                <div className="pills" role="list" style={{justifyContent:'center'}}>
                  {badges.map((b) => (
                    <span key={b} className="pill" role="listitem">{b}</span>
                  ))}
                </div>
              ) : null}
            </header>

            {/* price grid (uses your new blocks but with actual numbers) */}
            <div className="price-and-cta-sticky">
          {priceGrid.length !== 0 && <div
  className={`price-grid ${priceGrid.length === 1 ? 'price-grid--single' : ''}`}
  aria-label={t('Price summary')}
>
              {priceGrid.map(({ label, value }) => (
                <div className="price-item" key={label}>
                  <div className="label">{label}</div>
                  <div className="value2 pricing">
                    {value != null ? value.toLocaleString(undefined, { style: "currency", currency: "CAD" }) : t("N/A")}
                  </div>
                </div>
              ))}
            </div>}
</div>
{/* CTA row directly under prices */}
<div className="cta-row" style={{maxWidth:'none'}}>
  {/* {selectedCard?.isForSale === "isForSale" && !isOwner && (
    <SaleModals
      SellerId={selectedCard.UserId}
      BuyerId={userId}
      selectedCard={selectedCard}
      triggerLogin={triggerLogin}
      SellerShowName={selectedCard.ShowName}
      isFavorite={!!favoriteCards[selectedCard.userCardId]}
      toggleFavorite={toggleFavorite}
      liveCsrfToken={liveCsrfToken}
      SellerInfo={sellerInfo}
    />
  )}

  {selectedCard?.isForTrade === "isForTrade" && !isOwner &&  (
    <>
      <button
        className="btn-baseBlue"
        style={{padding:'16px'}}
        onClick={() => { if (!triggerLogin()) setIsTradeModalOpen(true); }}
        title={t("Propose Trade")}
      >
        {t("Trade")}
      </button>
      <ModalTradeOffer
        isOpen={isTradeModalOpen}
        onClose={() => setIsTradeModalOpen(false)}
        theirId={selectedCard.UserId}
        thisCurrentCard={[selectedCard]}
        yourId={userId}
        liveCsrfToken={liveCsrfToken}
      />
    </>
  )} */}
 <div className="title-row__meta">
                  {statusPills.map((p) => (
                    <span key={p} className="status-pill">{p}</span>
                  ))}
                
                </div>
    {saleAvailable && (
    <button
      className="cta-btn cta-btn---primary"
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        openSale();
      }}
      aria-label={t("Buy it Now")}
    >
      <div className="cta-content">
        <span className="cta-title">{t("Buy it Now")}</span>
        {/* tiny price label helps reinforce the action */}
        <span className="cta-sub">{formatCAD(selectedCard.Price)}</span>
      </div>
    </button>
  )}

  {tradeAvailable && (
    <button
      className={`cta-btn ${saleAvailable ? "cta-btn---ghost" : "cta-btn---primary"}`}
      type="button"
      title={t("Propose Trade")}
      aria-label={t("Propose Trade")}
      onClick={() => setIsTradeModalOpen(true)}
    >
      <div className="cta-content">
        <span className="cta-title">{t("Trade")}</span>
        {/* optional hint to reduce friction */}
        {!saleAvailable && Number(selectedCard?.EstimateValue) > 0 && (
          <span className="cta-sub">~ {formatCAD(selectedCard.EstimateValue)}</span>
        )}
      </div>
    </button>
  )}

       
                           {saleAvailable  && ( <SaleModals
    key={selectedCard.userCardId || selectedCard.id}   // forces remount per card
    isOpen={isSaleModalOpen}
    onClose={() => { setIsSaleModalOpen(false); }}
    selectedCard={selectedCard}
    SellerId={selectedCard.UserId}
    SellerShowName={selectedCard.ShowName}
    SellerInfo={{
      ShowName: selectedCard.ShowName,
      ProfilPicture: selectedCard.ProfilPicture,
      NumberOfTransactions: selectedCard.NumberOfTransactions,
      AverageX5: (selectedCard.AverageRating * 20).toFixed(1),
      City: selectedCard.City || 'Unknown',
      Country: selectedCard.Country || 'Unknown',
      CountryCode: getCountryCode(selectedCard.Country || 'NA'),
    }}
    BuyerId={userId}
    liveCsrfToken={liveCsrfToken}
    triggerLogin={triggerLogin}
  />)}


                      
                              {  tradeAvailable  && (
                                  <ModalTradeOffer
                                    isOpen={isTradeModalOpen}
                                    onClose={() => {
                                      setIsTradeModalOpen(false);
                                    }}
                                    theirId={selectedCard.UserId}
                                    thisCurrentCard={[selectedCard]}
                                    yourId={userId}
                                    liveCsrfToken={liveCsrfToken}
                                    triggerLogin={triggerLogin}
                                  />
                                )}


  {/* icons to the right of the CTA (like figma) */}
  <div className={`cta-icons ${isOwner ? 'NoMargin' : ''}`}>
     
    {!isOwner && <button className="icon-btn" type="button" aria-label={t("Like")}>
      <FavoriteIcon
        cardId={selectedCard.CardId}
        cardUserCardId={selectedCard.userCardId}
        isFavorite={favoriteCards.some((c) => c.userCardId === selectedCard.userCardId)}
        cardUserId={selectedCard.UserId}
        userId={userId}
        toggleFavorite={toggleFavorite}
        size={40}
      />
    </button>}
   <button
    className="icon-btn"
    type="button"
    aria-label={t("Share")}
    onClick={onShare}
    style={{ width: '36px !important' }}
  >
    <img src={iconShare} alt="" />
  </button>
  </div>
</div>




            {/* details grid (mapped from old model) */}
          <div className="details-grid">
  <div className="kv">
    <div className="k">{t("Set")}</div>
    <div className="v">{selectedCard?.SetName || t("N/A")}</div>
  </div>

  {isHockey ? (
    <>
      <div className="kv">
        <div className="k">{t("Variation")}</div>
        <div className="v">
          {`${selectedCard?.cardName || ""}${selectedCard?.variationName ? ` - ${selectedCard.variationName}` : ""}` || t("N/A")}
        </div>
      </div>

      <div className="kv">
        <div className="k">{t("Sport")}</div>
        <div className="v">{selectedCard?.Sport || "Hockey"}</div>
      </div>
    </>
  ) : (
    <>
      <div className="kv">
        <div className="k">{t("Card")}</div>
        <div className="v">{selectedCard?.cardName || selectedCard?.Name || t("N/A")}</div>
      </div>

      <div className="kv">
        <div className="k">{t("Card#")}</div>
        <div className="v">
          {selectedCard?.NumberInSet || selectedCard?.NumberBehind || t("N/A")}
        </div>
      </div>

      <div className="kv">
        <div className="k">{t("Rarity")}</div>
        <div className="v">{selectedCard?.Rarity || t("N/A")}</div>
      </div>

      {selectedCard?.HoloOverride ? (
        <div className="kv">
          <div className="k">{t("Holo")}</div>
          <div className="v">{selectedCard.HoloOverride}</div>
        </div>
      ) : null}
    </>
  )}

  {selectedCard?.Graded === "Raw" ? (
    <div className="kv">
      <div className="k">{t("Condition")}</div>
      <div className="v">{selectedCard?.ConditionCard || t("N/A")}</div>
    </div>
  ) : (
    <div className="kv">
      <div className="k">{t("Condition")}</div>
      <div className="v">{`${selectedCard?.GradeCompany || ""} ${selectedCard?.Grade || ""}`}</div>
    </div>
  )}

  {isHockey && (
    <div className="kv">
      <div className="k">{t("Uniform")}</div>
      <div className="v">{selectedCard?.playerUniform || t("N/A")}</div>
    </div>
  )}

  <div className="kv">
    <div className="k">{t("Location")}</div>
    <div className="v">{selectedCard?.Location || t("N/A")}</div>
  </div>

  <div className="kv">
    <div className="k">{t("Added On")}</div>
    <div className="v">
      {selectedCard?.InsertDate
        ? new Date(selectedCard.InsertDate).toLocaleDateString("en-CA")
        : t("N/A")}
    </div>
  </div>
</div>

    

            {/* seller row (right side in new, but we keep it here for simplicity) */}
            {parseInt(selectedCard?.UserId) !== parseInt(userId) && !isOwner && (
              <div className="seller">
                <img className="seller__avatar" src={selectedCard.ProfilPicture || require("../assets/svgs/profile.png")} alt="" />
                <span
                  className="seller__name link"
                  onClick={() => navigate(i18n.language === 'fr'
                    ? `/fr/ViewUserProfil/${selectedCard.ShowName}`
                    : `/ViewUserProfil/${selectedCard.ShowName}`)}
                >
                  {selectedCard.ShowName}
                </span>
                <a className="seller__score" href="#ratings">
                  {(selectedCard.AverageRating * 20).toFixed(1)}% ({selectedCard.NumberOfTransactions})
                </a>
              </div>
            )}

           
            {selectedCard?.Description && !isOwner ? (
              <p className="card-desc">{selectedCard.Description}</p>
            ) : null}

          <ReportFromFullPageListing
              asMenuItem
              role="menuitem"
              className="menu__item menu__item--danger"
              userId={userId}
              Data={selectedCard}
              liveCsrfToken={liveCsrfToken}
              label={t("Report issue")}
            />
          </section>
        </div>

        <img src={dividerLine} style={{ width: "100%", marginTop: 10 }} alt="" />
      </section>

      {/* related */}
      <div className="hero__carousel">
        <CarouselCardsSubsection title={t("Discover More Cards")} t={t} i18n={i18n} />
      </div>
    </main>
  );
};

export default ElementDetailOfACard;
